import React from 'react';
import { Table, Tag } from 'antd';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { filterColumns, renderWithTooltip } from 'utils/table';
import {
  kassaStatuses,
  kassaStatusesMap,
} from 'utils/handbooks/kassaHandbooks';
import { CheckboxFilter } from 'components/Filters/CheckboxFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { checkValue, formatDate } from 'utils';

function KassaTable({
  items,
  loading,
  current,
  pageSize,
  totalRows,
  allowFilter,
  filters = {},
  onFilter,
  onRowClick,
  onChange,
}) {
  const { status } = filters;

  const columns = [
    {
      title: 'Наименование компании',
      dataIndex: 'client',
      key: 'client',
      render: (value) => renderWithTooltip(value, 60),
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Tag>{kassaStatusesMap[status]}</Tag>,
      filterDropdown: () => (
        <CheckboxFilter
          filter={status}
          filters={kassaStatuses}
          onFilterChange={(status) => onFilter({ status })}
        />
      ),
      filterIcon: () => <FilterIcon isActive={status} />,
    },
    {
      title: 'Дата начала',
      dataIndex: 'created_date',
      key: 'created_date',
      render: (value) => (value ? formatDate(value) : '---'),
    },
    {
      title: 'Дата обновления',
      dataIndex: 'updated_date',
      key: 'updated_date',
      render: (value) => (value ? formatDate(value) : '---'),
    },
    {
      title: 'Логин ОФД',
      dataIndex: 'ofd_credentials_login',
      key: 'ofd_credentials_login',
      render: checkValue,
    },
    {
      title: 'Логин партнер',
      dataIndex: 'kassa_credentials_email',
      key: 'kassa_credentials_email',
      render: checkValue,
    },
  ];

  return (
    <Table
      columns={filterColumns(columns, allowFilter)}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        if (onRowClick) {
          return {
            onDoubleClick: () => onRowClick(record),
          };
        }
        return null;
      }}
      onChange={onChange}
    />
  );
}

export { KassaTable };
